"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withReduxForm = _interopRequireDefault(require("../../libs/hocs/withReduxForm"));

var _utils = require("../../libs/utils");

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _labelContainer = _interopRequireDefault(require("./styled/labelContainer"));

var _label = _interopRequireDefault(require("./styled/label"));

var _hiddenElement = _interopRequireDefault(require("../Structural/hiddenElement"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Checkbox toggle is a checkable input that communicates if an option is true,
 * false or indeterminate.
 * @category Form
 */
var CheckboxToggle = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CheckboxToggle, _Component);

  var _super = _createSuper(CheckboxToggle);

  function CheckboxToggle(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckboxToggle);
    _this = _super.call(this, props);
    _this.checkboxToggleRef = /*#__PURE__*/_react["default"].createRef();
    _this.inputIndentifier = props.name || (0, _utils.uniqueId)('checkbox-toggle');
    return _this;
  }
  /**
   * Sets focus on the element.
   * @public
   */


  (0, _createClass2["default"])(CheckboxToggle, [{
    key: "focus",
    value: function focus() {
      this.checkboxToggleRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: "click",
    value: function click() {
      this.checkboxToggleRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: "blur",
    value: function blur() {
      this.checkboxToggleRef.current.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          disabled = _this$props.disabled,
          label = _this$props.label,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          id = _this$props.id,
          labelAlignment = _this$props.labelAlignment;
      return /*#__PURE__*/_react["default"].createElement(_labelContainer["default"], {
        labelAlignment: labelAlignment,
        id: id,
        className: className,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_hiddenElement["default"], {
        as: "input",
        type: "checkbox",
        name: this.inputIndentifier,
        value: this.inputIndentifier,
        "aria-describedby": this.inputIndentifier,
        checked: value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        disabled: disabled,
        ref: this.checkboxToggleRef
      }), /*#__PURE__*/_react["default"].createElement("span", {
        id: this.inputIndentifier,
        className: "rainbow-checkbox-toggle_faux-container",
        "aria-live": "assertive"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "rainbow-checkbox-toggle_faux"
      })), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: label
      }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
        labelAlignment: labelAlignment
      }, label)));
    }
  }]);
  return CheckboxToggle;
}(_react.Component);

CheckboxToggle.propTypes = {
  /** Text label for the checkbox toggle. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The name of the input */
  name: _propTypes["default"].string,

  /** The value of the element. */
  value: _propTypes["default"].bool,

  /** Specifies that the element should be disabled. This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes["default"].func,

  /** The action triggered when the element is clicked. */
  onClick: _propTypes["default"].func,

  /** The action triggered when the element receives focus. */
  onFocus: _propTypes["default"].func,

  /** The action triggered when the element releases focus. */
  onBlur: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** Describes the position of the Toggle label. Options include top, left and right.
   * This value defaults to right. */
  labelAlignment: _propTypes["default"].oneOf(['left', 'right', 'top'])
};
CheckboxToggle.defaultProps = {
  label: null,
  disabled: false,
  value: false,
  name: undefined,
  onChange: function onChange() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  className: undefined,
  style: undefined,
  id: undefined,
  labelAlignment: 'right'
};

var _default = (0, _withReduxForm["default"])(CheckboxToggle);

exports["default"] = _default;